export const GET_CALENDAR_EVENT_BEGIN = 'GET_CALENDAR_EVENT_BEGIN'
export const GET_CALENDAR_EVENT_SUCCESS = 'GET_CALENDAR_EVENT_SUCCESS'
export const GET_CALENDAR_EVENT_ERROR = 'GET_CALENDAR_EVENT_ERROR'

export const CREATE_CALENDAR_EVENT_BEGIN = 'CREATE_CALENDAR_EVENT_BEGIN'
export const CREATE_CALENDAR_EVENT_SUCCESS = 'CREATE_CALENDAR_EVENT_SUCCESS'
export const CREATE_CALENDAR_EVENT_ERROR = 'CREATE_CALENDAR_EVENT_ERROR'

export const UPDATE_CALENDAR_EVENT_BEGIN = 'UPDATE_CALENDAR_EVENT_BEGIN'
export const UPDATE_CALENDAR_EVENT_SUCCESS = 'UPDATE_CALENDAR_EVENT_SUCCESS'
export const UPDATE_CALENDAR_EVENT_ERROR = 'UPDATE_CALENDAR_EVENT_ERROR'

export const DELETE_CALENDAR_EVENT_BEGIN = 'DELETE_CALENDAR_EVENT_BEGIN'
export const DELETE_CALENDAR_EVENT_SUCCESS = 'DELETE_CALENDAR_EVENT_SUCCESS'
export const DELETE_CALENDAR_EVENT_ERROR = 'DELETE_CALENDAR_EVENT_ERROR'